export const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
export const isIpad = (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    || (/iPad/.test(navigator.userAgent));
export const isIphoneFullscreen = isIos && document.body.classList.contains('fullscreen-fallback-active');